/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M161.587 501.64c-9.805 0-19.559-4.147-26.394-12.21-12.34-14.567-10.521-36.378 4.02-48.717l218.009-184.781L139.212 70.92c-14.566-12.365-16.358-34.176-3.993-48.717 12.313-14.541 34.201-16.359 48.69-3.994l249.089 211.38a34.478 34.478 0 0112.186 26.367 34.55 34.55 0 01-12.186 26.343L183.91 493.449a34.396 34.396 0 01-22.323 8.192"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconBracketRight = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconBracketRight.defaultProps = {
  theme,
};
IconBracketRight.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconBracketRight.displayName = 'IconBracketRight';
export { IconBracketRight };
